<template>
  <!--<div class="w3-row">
    <div class="w3-col" style="width:20%"><div style="width: 5px; height: 5px; border-radius: 2px;"></div></div>
    <div class="w3-col" style="width:20%"><p>20%</p></div>
    <div class="w3-col" style="width:20%"><p>20%</p></div>
    <div class="w3-col" style="width:20%"><p>20%</p></div>
    <div class="w3-col" style="width:20%"><p>20%</p></div>
  </div>-->
</template>

<script>
    export default {
        name: "QuickMenu"
    }
</script>

<style scoped>
  /*div{
    border: #3a3a3a 1px solid;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/QuickMenu.vue